import ArticleTemplate from '@/pages/article/components/ArticleTemplate';

export default function ArticleSaving() {
  return <ArticleTemplate slug="sugargoo-saving-tips" />;
}